export default {
  _default: {
    serverUrl: '/web/',
    projectKey: 'cts-web',
    serviceCode: 'web',
    excelImportConfig: {
      filter: 'csv,xls,xlsx', // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  otherClient: {
    serverUrl: '/dev-api/web/',
    projectKey: 'cts-web',
    serviceCode: 'web',
    excelImportConfig: {
      filter: 'csv,xls,xlsx', // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  pgClient: {
    serverUrl: '/web/',
    projectKey: 'cts-web',
    serviceCode: 'web',
    excelImportConfig: {
      filter: 'csv,xls,xlsx', // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  esClient: {
    serverUrl: '/web/',
    projectKey: 'cts-web',
    serviceCode: 'web',
    excelImportConfig: {
      filter: 'csv,xls,xlsx', // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  }
};
